import Seo from "../components/Seo";
import { useEffect, useState } from "react";
import teamFallback from "../data/home/team.json";
import pageFallback from "../data/teamsPage.json";
import { loadSection } from "../services/contentSource";

const Teams = () => {
  // The eight members here were the theme's demo staff, complete with
  // placeholder images and a CEO of "Wealcoder" — the theme vendor. The real
  // team has been in the CMS the whole time; this page simply never read it.
  const [members, setMembers] = useState<any[]>([]);
  const [page, setPage] = useState<any>(pageFallback);

  useEffect(() => {
    loadSection("team", teamFallback as any).then(({ data }) =>
      setMembers(((data as any)?.members) || [])
    );
    loadSection("teamsPage", pageFallback as any).then(({ data: main }) => {
      if (main) setPage(main);
    });
  }, []);

  return (
    <>
      <Seo
        title="Team"
        description="The engineers, architects and operators behind the MindSyncX platform."
        path="/teams"
      />
      <link rel="stylesheet" href="/assets/css/master-team.css"></link>
      <main>
        {/* hero area start  */}
        <section className="hero-area">
          <div className="container large">
            <div className="hero-area-inner">
              <div className="section-content">
                <div
                  className="btn-wrapper has_fade_anim"
                  data-fade-from="left"
                >
                  <a href="/contact" className="wc-btn wc-btn-underline">
                    {page.hero.ctaText}
                    <i className="fa-solid fa-arrow-right" />
                  </a>
                </div>
                <div className="content-last">
                  <div className="section-title-wrapper">
                    <div className="title-wrapper">
                      <h1 className="section-title large has_text_move_anim">
                        {page.hero.title}
                      </h1>
                    </div>
                  </div>
                  <div className="text-wrapper">
                    <p className="text has_fade_anim" data-fade-from="left">
                      {page.hero.lede}
                    </p>
                  </div>
                  <div
                    className="fun-fact has_fade_anim"
                    data-fade-from="bottom"
                  >
                    <span className="number wc-counter">{page.hero.statValue}</span>
                    <p className="text">{page.hero.statLabel}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="image-wrapper">
          <div className="container large">
            <div className="p-relative">
              <div
                className="experience has_fade_anim"
                data-fade-from="top"
                data-ease="bounce"
              >
                <h2 className="number wc-counter">{page.imageStrip.statValue}</h2>
                <h2 className="text">
                  {page.imageStrip.statLabelLine1} <br />
                  {page.imageStrip.statLabelLine2}
                </h2>
              </div>
            </div>
          </div>
          <img
            className="w-100 has_fade_anim"
            data-on-scroll={0}
            src="/assets/imgs/gallery/img-s-104.webp"
            alt="image" loading="lazy" decoding="async" />
        </div>
        {/* hero area end  */}
        {/* team area start  */}
        <section className="team-area">
          <div className="container">
            <div className="team-area-inner section-spacing">
              <div className="section-header">
                <div className="section-title-wrapper">
                  <div className="title-wrapper">
                    <h2 className="section-title has_text_move_anim">
                      {page.teamSection.title}
                    </h2>
                  </div>
                </div>
                <div className="text-wrapper">
                  <p className="text has_fade_anim">
                    {page.teamSection.lede}
                  </p>
                </div>
              </div>
              <div className="team-wrapper-box">
                <div className="team-wrapper">
                  {members.map((member: any, index: number) => (
                    <div
                      className="team-box has_fade_anim"
                      data-delay={`0.${15 + index * 15}`}
                      key={member.id || index}
                    >
                      <a href={`/team-details/${member.slug || member.id || index}`}>
                        <div className="thumb">
                          <img
                            src={member.image || member.img}
                            alt={member.name}
                            loading="lazy"
                            decoding="async"
                          />
                        </div>
                        <div className="content">
                          <h3 className="title">{member.name}</h3>
                          <p className="text">{member.role || member.designation}</p>
                        </div>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* team area end  */}
        {/* counter area start  */}
        {/* community area start  */}
        <section className="community-area">
          <div className="container">
            <div className="community-area-inner section-spacing">
              <div className="section-content">
                <div className="section-title-wrapper">
                  <div className="title-wrapper">
                    <h2 className="section-title has_fade_anim">
                      {page.community.title}
                    </h2>
                  </div>
                </div>
                <div className="text-wrapper">
                  <p className="text has_fade_anim">
                    {page.community.text}
                  </p>
                </div>
                <div className="gallery-wrapper-box">
                  <div className="gallery-wrapper has_fade_anim">
                    <div className="">
                      <div className="thumb">
                        <img
                          src="/assets/imgs/gallery/img-s-94.webp"
                          alt="image" loading="lazy" decoding="async" />
                      </div>
                    </div>
                    <div className="">
                      <div className="thumb">
                        <img
                          src="/assets/imgs/gallery/img-s-95.webp"
                          alt="image" loading="lazy" decoding="async" />
                      </div>
                    </div>
                    <div className="">
                      <div className="thumb">
                        <img
                          src="/assets/imgs/gallery/img-s-96.webp"
                          alt="image" loading="lazy" decoding="async" />
                      </div>
                      <div className="thumb">
                        <img
                          src="/assets/imgs/gallery/img-s-97.webp"
                          alt="image" loading="lazy" decoding="async" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* community area end  */}
      </main>
    </>
  );
};
export default Teams;
